<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('despachosmina')">Orden de Despacho</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>Agregar
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <label class="pr-6 pb-8">Fecha:</label>
        <Datepicker  v-model="form.fecha" :error="form.errors.fecha" class="pr-6 pb-8 w-full lg:w-6/6" format="YYYY-MM-DD H:i:s" />

          <select-input v-model="form.maquinaria_id" :error="form.errors.maquinaria_id" class="pr-6 pb-8 w-full lg:w-1/3" label="Maquinaria/Vehiculo" required>
            <option v-for="maquinaria in maquinarias" :key="maquinaria.id" :value="maquinaria.id">{{ maquinaria.codigo }} - {{ maquinaria.clase}} - {{maquinaria.placas}}</option>
        </select-input>
        <select-input v-model="form.operador" :error="form.errors.operador" class="pr-6 pb-8 w-full lg:w-1/3" label="Operador" required>
            <option v-for="conductor in conductores" :key="conductor.id">{{ conductor.nombres }} {{ conductor.apellidos }}</option>
        </select-input>
        <select-input v-model="form.proyecto" :error="form.errors.proyecto" class="pr-6 pb-8 w-full lg:w-1/3" label="Destino de Proyecto" required>
            <option v-for="proyecto in proyectos" :key="proyecto.id">{{ proyecto.nombre}}</option>
        </select-input>
        <select-input v-model="form.material" :error="form.errors.material" class="pr-6 pb-8 w-full lg:w-2/5" label="Tipo de Material" required>
          <option>ARENA DE BANCO</option>  
          <option>BASE CRIBADA</option>  
             <option>BASE TRITURADA</option>
             <option>RIPIO</option>
            <option>SUB-BASE</option>
            <option>PIEDRA BOLA</option>
            <option>ESCOLLERA</option>
            <option>LASTRE</option>
            <option>MEJORAMIENTO</option>
            <option>POLVO DE PIEDRA</option>
            <option>ARENA AZUL LAVADA</option>
        </select-input>
        <text-input v-model="form.capacidad" :error="form.errors.capacidad" class="pr-6 pb-8 w-full lg:w-1/5" label="Capacidad M3" required/>
        <select-input v-model="form.proveedor" :error="form.errors.proveedor" class="pr-6 pb-8 w-full lg:w-1/5" label="Proveedor" required>
            <option>PETRUSMIN</option>
        </select-input>
            <text-input v-model="form.cantidad" :error="form.errors.cantidad" class="pr-6 pb-8 w-full lg:w-1/5" label="Nº de Despachos" required/>
        <text-input v-model="form.observaciones" :error="form.errors.observaciones" class="pr-6 pb-8 w-full lg:w-1/1" label="Observación" />
      
          </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Agregar Orden Despacho Cofiza</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Datepicker from 'vuejs-datetimepicker'

export default {
  metaInfo: { title: 'Add Orden Despacho Cofiza' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
     Datepicker
  },
  layout: Layout,
  props: {
    maquinarias: Array,
    proyectos: Array,
    conductores: Array,


  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        maquinaria_id: null,
        proyecto: null,
        operador: null,
        cantidad: null,
        fecha: null,
        material: null,
        observaciones: null,
        capacidad: null,
        proveedor: null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('despachosordenes.store'))
    },
  },
}
</script>
